import { render, staticRenderFns } from "./PlayerStatsWidget.vue?vue&type=template&id=51e3d783&scoped=true"
import script from "./PlayerStatsWidget.vue?vue&type=script&lang=js"
export * from "./PlayerStatsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e3d783",
  null
  
)

export default component.exports